import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

import { CategoriesContext } from "../../contexts/categories.context";

import ProductCard from "../../components/product-card/product-card.component";

import { CategoryContainer, CategoryTitle } from "./category.styles";

const Category = () => {
  const { categoryId } = useParams();
  const { categoriesMap } = useContext(CategoriesContext);

  const [products, setProducts] = useState(categoriesMap[categoriesMap]);

  useEffect(() => {
    setProducts(categoriesMap[categoryId]);
  }, [categoryId, categoriesMap]);

  return (
    <>
      <CategoryTitle>{categoryId.toUpperCase()}</CategoryTitle>
      <CategoryContainer>
        {products &&
          products.map((p) => <ProductCard key={p.id} product={p} />)}
      </CategoryContainer>
    </>
  );
};

export default Category;
